import React from "react";
import { Box } from "@mui/material";

const TableHead = (): React.ReactElement => {
  return (
    <thead>
      <Box
        component="tr"
        sx={{
          "& th": {
            verticalAlign: "baseline",
            fontSize: "14px",
          },
        }}
      >
        <th>Platform</th>
        <th>Plan Name</th>
        <th>Purchase Date</th>
        <th>Rebill Date</th>
        <th>Initial Plan Price</th>
        <th>Current Plan Price</th>
        <th>Active</th>
        <th>Discount</th>
        <th>Discount Applied Until</th>
        <th>Available free resets</th>
        <th />
      </Box>
    </thead>
  );
};

export default TableHead;
